export class DateTimeUtils {
  public static toFormLocalDateTime(date: Date): string | null {
    if(!date) {
      return null;
    } else if(date.getFullYear() < 2000) {
      return null;
    }

    return date.toISOString().slice(0, -1);
  }

  public static isDateCorrupted(date: Date): boolean {
    return date.getFullYear() < 2000;
  }
}
